import { useQuery } from "@apollo/client";
import { Combobox } from "@/components/Combobox";
import { graphql, type ResultOf } from "@/graphql";
import { removeNothings } from "@/lib/utils/arrays";
import { type StateCode, isValidStateCode, STATE_DATA } from "@/lib/utils/states";

type Props = {
  id?: string;
  selected: Array<StateCode>;
  onSelect: (values: Array<StateCode>) => void;
  className?: string;
};

export type DestinationStateData = ResultOf<typeof destinationStateCodesQuery>;

export function DestinationStatePicker({ id, selected, onSelect, className }: Props) {
  const { data, loading } = useQuery(destinationStateCodesQuery);

  const options = getStateOptions(removeNothings(data?.supplyChainLotDestinationStateCodes || []));

  return (
    <Combobox<StateCode>
      id={id}
      name="destination-states"
      options={options}
      selected={selected}
      onChange={onSelect}
      loading={loading}
      type="multi"
      className={className}
    />
  );
}

export const destinationStateCodesQuery = graphql(`
  query SupplyChainLotDestinationStateCodes {
    supplyChainLotDestinationStateCodes
  }
`);

export const getStateOptions = (stateCodes: string[]) => {
  const options = stateCodes.filter(isValidStateCode).map((stateCode) => {
    return {
      label: STATE_DATA[stateCode],
      value: stateCode,
    };
  });

  return options;
};
